export const resetSnackbarNotification =
  (setStateById: (id: string, stateChange: (prevState) => any) => void) => async () => {
    setStateById('RESET_NOTIFICATION_SNACKBAR', (s) => ({
      ...s,
      snackbarNotification: undefined,
    }));
  };
